module.exports = __webpack_public_path__ + "img/IMG_1962_P_WoodMatted.058c8c9e.jpg";